<script>
import imgPriceSendShipping from '@/assets/imgs/price-send-shipping.png';
import imgPriceStorage from '@/assets/imgs/price-storage.png';
import imgPriceReturnShipping from '@/assets/imgs/price-return-shipping.png';

export default {
  name: 'BillProcessDialog',
  data() {
    return {
      priceIncludeList: [
        {
          image: imgPriceSendShipping,
          title: 'Send shipping',
          content: [
            'When creating the shipment order, we will pre-charge the shipping fee based on 50 lbs for each package.',
          ],
        },
        {
          image: imgPriceStorage,
          title: 'Storage',
          content: [
            'After inbounded, we\'ll recalculate order charges based on actual weight and dimensions, and adjust any difference to your credit card.\n' +
              'Subsequently, we will charge the storage fee to your credit card every 7 days.',
          ],
        },
        {
          image: imgPriceReturnShipping,
          title: 'Return shipping',
          content: [
            'Once you confirm the return date and return address and create the return order, we will charge the return shipping fee to your credit card.',
          ],
        },
      ],
    };
  },
};
</script>

<template>
  <i-dialog v-bind="$attrs" v-on="$listeners">
    <i-timeline direction="vertical" style="margin: 20px 0 0 100px">
      <i-timeline-item v-for="item in priceIncludeList" :key="item.title">
        <template v-slot:dot>
          <div style="position: absolute; left: -70px">
            <img :src="item.image" :alt="item.title" style="width: 60px" />
          </div>
          <img src="@/assets/imgs/home-icon-down.jpg" style="height: 10px" />
        </template>
        <template>
          <div class="package-limit-card">
            <div class="title">{{ item.title }}</div>
            <div class="content">
              <div v-for="(content, index) in item.content" :key="index" style="white-space: pre-line">
                {{ content }}
              </div>
            </div>
          </div>
        </template>
      </i-timeline-item>
    </i-timeline>
  </i-dialog>
</template>

<style scoped lang="less">
@import '../../assets/fonts/font.less';
.package-limit-card {
  padding: 0 27px 27px 7px;
  .title {
    .font-regular;
    font-weight: 400;
    font-size: 14px;
    color: #262626;
  }
  .content {
    .font-light;
    margin-top: 6px;
    font-weight: 300;
    font-size: 12px;
    color: #afb5c6;
    line-height: 15px;
  }
}
</style>
